<template>
    <div>
        <el-card shadow='never' class='box-card'>
            <div style='margin-top: 1rem;margin-bottom: 1rem;' class='class_condition'
                 v-for='(item, index) in selectedConditionMap' :key='index'>
                <el-row>
                    <el-col :span='23'>
                        <el-row :gutter='30'>
                            <el-col :span='8'>
                                <el-tag size='medium'>{{ item[0] }}</el-tag>
                            </el-col>
                            <el-col :span='6'>
                                <el-select @change='handleChange($event, item[1])' v-model='item[1].selectKey'
                                           placeholder='请选择条件'>
                                    <el-option
                                        v-for="option in item[1]['options']"
                                        :key='option.key'
                                        :label='option.label'
                                        :value='option.key'>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col v-if='computeShowInputBox(item[1])' :span='10'>
                                <class-edit :key='item[1].active.key' :origin-value='item[1].active.inputValue'
                                            input-box-type='text'
                                            @getNewClassValue='getEditedColumnValue($event, item[1])'
                                            :type='item[1].fieldType' />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span='1'>
                        <span @click='removeCondition(item, index)' class='el-icon-minus'
                              style='cursor: pointer;float: right'></span>
                    </el-col>
                </el-row>
            </div>
            
            <div style='margin-top: 1rem;'>
                <el-row :gutter='20'>
                    <el-col :span='12'>
                        <el-select @change='addCondition' filterable v-model='selectTempValue' placeholder='请选择字段'>
                            <el-option
                                v-for='item in filterFieldOption'
                                :key='item.fieldName'
                                :label='item.fieldName'
                                :value='item.fieldName'>
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span='12'>
                        <div>
                            <el-button type='info' @click='handleCleanAll'>清 空</el-button>
                            <el-button type='primary' @click='executeQuery'>{{ queryButtonText }}</el-button>
                            <slot />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import ClassEdit from '@/components/component/storage/ClassEdit.vue';
import { deepCopy } from '@/utils/object';
import { message } from '@/utils/message';

export default defineComponent({
    name: 'ClassFilter',
    components: { ClassEdit },
    data() {
        return {
            typeOperationOption: {
                Common: [
                    {
                        label: '存在',
                        key: 'exists',
                        showInputBox: false,
                        inputValue: true
                    },
                    {
                        label: '不存在',
                        key: 'does_not_exist',
                        showInputBox: false,
                        inputValue: true
                    }
                ],
                Number: [
                    {
                        label: '等于',
                        key: 'equals',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '不等于',
                        key: 'does_not_equal',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '大于',
                        key: 'greater_than',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '大于等于',
                        key: 'greater_than_or_equal',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '小于',
                        key: 'less_than',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '小于等于',
                        key: 'less_than_or_equal',
                        showInputBox: true,
                        inputValue: undefined
                    }
                ],
                String: [
                    {
                        label: '等于',
                        key: 'equals',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '不等于',
                        key: 'does_not_equal',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: 'starts with',
                        key: 'starts_with',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: 'ends with',
                        key: 'ends_with',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '包含字符串',
                        key: 'contains_string',
                        showInputBox: true,
                        inputValue: undefined
                    }
                ],
                Boolean: [
                    {
                        label: '等于',
                        key: 'equals',
                        showInputBox: true,
                        inputValue: true
                    },
                    {
                        label: '不等于',
                        key: 'does_not_equal',
                        showInputBox: true,
                        inputValue: true
                    }
                ],
                Date: [
                    {
                        label: 'is before',
                        key: 'is_before',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: 'is after',
                        key: 'is_after',
                        showInputBox: true,
                        inputValue: undefined
                    }
                ],
                Object: [
                    {
                        label: 'key存在',
                        key: 'key_exists',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: 'key不存在',
                        key: 'key_not_exist',
                        showInputBox: true,
                        inputValue: undefined
                    }
                
                ],
                Array: [
                    {
                        label: '包含字符串',
                        key: 'contains_string',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '不包含字符串',
                        key: 'without_string',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '包含数字',
                        key: 'contains_number',
                        showInputBox: true,
                        inputValue: undefined
                    },
                    {
                        label: '不包含数字',
                        key: 'without_number',
                        showInputBox: true,
                        inputValue: undefined
                    }
                ]
            },
            filterFieldOption: [],
            selectedConditionMap: new Map,
            tempOption: {},
            selectTempValue: undefined
        };
    },
    emits: ['getFilterCondition'],
    props: {
        allType: {
            type: Object
        },
        queryButtonText: {
            type: String,
            default: () => {
                return '查 询';
            }
        },
        initialWhere: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },
    created() {
        this.init();
    },
    watch: {
        initialWhere: {
            handler(newVal) {
                if (newVal) {
                    this.parseInitialWhere(newVal);
                }
            },
            immediate: true
        }
    },
    computed: {
        computeShowInputBox() {
            return (t) => {
                return !!(t.active && t.active.showInputBox && t.active.showInputBox === true);
                
            };
        }
    },
    methods: {
        init() {
            this.selectedConditionMap = new Map;
            let keys = Object.keys(this.typeOperationOption);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                if (key === 'Common') {
                    continue;
                }
                this.typeOperationOption['Common'].forEach(t => {
                    this.typeOperationOption[key].push(t);
                });
                if (i === keys.length - 1) {
                    let fieldNameArr = Object.keys(this.allType);
                    fieldNameArr.forEach((fieldName, index) => {
                        let fieldInfo = this.allType[fieldName];
                        
                        let option = {
                            fieldName: fieldName,
                            fieldType: fieldInfo.type,
                            operatorOption: this.typeOperationOption[fieldInfo.type]
                        };
                        if (!option.operatorOption) {
                            return;
                        }
                        this.filterFieldOption.push(option);
                    });
                }
            }
        },
        handleCleanAll() {
            this.selectedConditionMap.clear();
            this.$forceUpdate();
        },
        addCondition(value) {
            if (this.selectedConditionMap.has(value)) {
                message.info('不能重复设置!');
                return;
            }
            this.filterFieldOption.forEach(t => {
                if (t.fieldName === value) {
                    let filterInfo = deepCopy(t);
                    this.selectedConditionMap.set(filterInfo.fieldName, {
                        options: filterInfo.operatorOption,
                        active: {},
                        fieldType: filterInfo.fieldType,
                        selectKey: undefined
                    });
                    this.$forceUpdate();
                    this.selectTempValue = undefined;
                }
            });
        },
        removeCondition(item, index) {
            this.selectedConditionMap.delete(item[0]);
            this.$forceUpdate();
        },
        async generateStringSelectCondition(selectKey, inputValue) {
            if (!inputValue) {
                inputValue = '';
            }
            return new Promise((resolve, reject) => {
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'equals':
                        resolve(inputValue);
                        return;
                    case 'does_not_equal':
                        resolve({ '$ne': inputValue });
                        return;
                    case 'starts_with':
                        resolve({ '$regex': `^\\Q${inputValue}\\E` });
                        return;
                    case 'ends_with':
                        resolve({ '$regex': `\\Q${inputValue}\\E$` });
                        return;
                    case 'contains_string':
                        resolve({
                            '$options': 'i',
                            '$regex': inputValue
                        });
                }
            });
        },
        async generateNumberSelectCondition(selectKey, inputValue) {
            return new Promise((resolve, reject) => {
                if (inputValue) {
                    inputValue = parseFloat(inputValue);
                } else {
                    if (selectKey !== 'exists' && selectKey !== 'does_not_exist') {
                        resolve(null);
                    }
                }
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'equals':
                        resolve(inputValue);
                        return;
                    case 'does_not_equal':
                        resolve({ '$ne': inputValue });
                        return;
                    case 'greater_than':
                        resolve({ '$gt': inputValue });
                        return;
                    case 'greater_than_or_equal':
                        resolve({ '$gte': inputValue });
                        return;
                    case 'less_than':
                        resolve({ '$lt': inputValue });
                        return;
                    case 'less_than_or_equal':
                        resolve({ '$lte': inputValue });
                        return;
                }
            });
        },
        async generateArraySelectCondition(selectKey, inputValue) {
            return new Promise((resolve, reject) => {
                if (!inputValue) {
                    if (selectKey !== 'exists' && selectKey !== 'does_not_exist') {
                        resolve(null);
                    }
                }
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'contains_string':
                        resolve(inputValue);
                        return;
                    case 'without_string':
                        resolve({ '$ne': inputValue });
                        return;
                    case 'contains_number':
                        resolve(inputValue);
                        return;
                    case 'without_number':
                        resolve({ '$ne': inputValue });
                        return;
                }
            });
        },
        async generateDateSelectCondition(selectKey, inputValue) {
            return new Promise((resolve, reject) => {
                if (!inputValue) {
                    if (selectKey !== 'exists' && selectKey !== 'does_not_exist') {
                        resolve(null);
                    }
                }
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'is_before':
                        resolve({ '$lte': { '__type': 'Date', 'iso': new Date(inputValue) } });
                        return;
                    case 'is_after':
                        resolve({ '$gte': { '__type': 'Date', 'iso': new Date(inputValue) } });
                        return;
                }
            });
        },
        async generateObjectSelectCondition(selectKey, inputValue) {
            return new Promise((resolve, reject) => {
                if (!inputValue) {
                    if (selectKey !== 'exists' && selectKey !== 'does_not_exist') {
                        resolve(null);
                    }
                }
                let data = {};
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'key_exists':
                        data[inputValue] = {
                            '$exists': true
                        };
                        resolve(data);
                        return;
                    case 'key_not_exist':
                        data[inputValue] = {
                            '$exists': false
                        };
                        resolve(data);
                        return;
                }
            });
        },
        async generateBooleanSelectCondition(selectKey, inputValue) {
            return new Promise((resolve, reject) => {
                if (!inputValue) {
                    if (selectKey !== 'exists' && selectKey !== 'does_not_exist') {
                        resolve(null);
                    }
                }
                switch (selectKey) {
                    case 'exists':
                        resolve({ '$exists': true });
                        return;
                    case 'does_not_exist':
                        resolve({ '$exists': false });
                        return;
                    case 'equals':
                        resolve(inputValue);
                        return;
                    case 'does_not_equal':
                        resolve({ '$ne': inputValue });
                        return;
                }
            });
        },
        async generateMongoCondition(conditionArr) {
            if (conditionArr.length === 0) {
                return undefined;
            }
            if (conditionArr.length === 1) {
                return conditionArr[0];
            }
            return {
                '$and': conditionArr
            };
        },
        async convertCondition() {
            const mapEntries = Array.from(this.selectedConditionMap.entries());
            let conditionArr = [];
            for (let i = 0; i < mapEntries.length; i++) {
                const [fieldName, value] = mapEntries[i];
                let fieldType = value.fieldType;
                let selectKey = value.selectKey;
                let activeCondition = value.active;
                let inputValue = activeCondition.inputValue;
                let conditionValue = undefined;
                if (!activeCondition || Object.keys(activeCondition).length === 0) {
                    message.error(`${fieldName} 字段没有选择条件,查询将时将移除${fieldName}字段!`);
                    if (i === mapEntries.length - 1) {
                        return await this.generateMongoCondition(conditionArr);
                    }
                    continue;
                }
                switch (fieldType) {
                    case 'String':
                        conditionValue = await this.generateStringSelectCondition(selectKey, inputValue);
                        break;
                    case 'Date':
                        conditionValue = await this.generateDateSelectCondition(selectKey, inputValue);
                        break;
                    case 'Boolean':
                        conditionValue = await this.generateBooleanSelectCondition(selectKey, inputValue);
                        break;
                    case 'Array':
                        conditionValue = await this.generateArraySelectCondition(selectKey, inputValue);
                        break;
                    case 'Number':
                        conditionValue = await this.generateNumberSelectCondition(selectKey, inputValue);
                        break;
                    case 'Object':
                        conditionValue = await this.generateObjectSelectCondition(selectKey, inputValue);
                        break;
                }
                if (!conditionValue) {
                    message.error(`${fieldName} 字段没有设置正确的值,查询将时将移除${fieldName}字段!`);
                    if (i === mapEntries.length - 1) {
                        return await this.generateMongoCondition(conditionArr);
                    }
                    continue;
                }
                let condition = {};
                condition[fieldName] = conditionValue;
                conditionArr.push(condition);
                if (i === mapEntries.length - 1) {
                    return await this.generateMongoCondition(conditionArr);
                }
            }
        },
        async executeQuery() {
            let condition = await this.convertCondition();
            if (!condition) {
                condition = {};
            }
            this.$emit('getFilterCondition', condition);
        },
        handleChange(key, item) {
            item['options'].forEach(t => {
                if (t.key === key) {
                    item.active = t;
                    this.$forceUpdate();
                }
            });
        },
        getEditedColumnValue(value, item) {
            item.active.inputValue = value;
            this.$forceUpdate();
        },
        // 反解析where条件
        async parseInitialWhere(whereCondition) {
            if (!whereCondition || !this.allType) {
                return;
            }
            
            // 清空现有条件
            this.selectedConditionMap.clear();
            
            // 处理$and条件
            let conditions = [];
            if (whereCondition.$and && Array.isArray(whereCondition.$and)) {
                conditions = whereCondition.$and;
            } else if (typeof whereCondition === 'object' && Object.keys(whereCondition).length > 0) {
                // 单个条件
                conditions = [whereCondition];
            }
            
            for (let condition of conditions) {
                await this.parseCondition(condition);
            }
            
            this.$forceUpdate();
        },
        // 解析单个条件
        async parseCondition(condition) {
            const fieldNames = Object.keys(condition);
            
            for (let fieldName of fieldNames) {
                const fieldValue = condition[fieldName];
                const fieldInfo = this.allType[fieldName];
                
                if (!fieldInfo) {
                    continue; // 跳过不存在的字段
                }
                
                const fieldType = fieldInfo.type;
                const operatorOption = this.typeOperationOption[fieldType];
                
                if (!operatorOption) {
                    continue;
                }
                
                // 解析条件值，获取操作符和输入值
                const parsedCondition = await this.parseConditionValue(fieldValue, fieldType);
                
                if (parsedCondition) {
                    // 找到匹配的操作选项
                    const matchedOption = operatorOption.find(opt => opt.key === parsedCondition.key);
                    
                    if (matchedOption) {
                        // 创建条件项
                        const conditionItem = {
                            options: operatorOption,
                            active: {
                                ...matchedOption,
                                inputValue: parsedCondition.inputValue
                            },
                            fieldType: fieldType,
                            selectKey: parsedCondition.key
                        };
                        
                        this.selectedConditionMap.set(fieldName, conditionItem);
                    }
                }
            }
        },
        // 解析条件值，返回操作符和输入值
        async parseConditionValue(fieldValue, fieldType) {
            // 处理存在性检查
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$exists === true) {
                    return { key: 'exists', inputValue: true };
                }
                if (fieldValue.$exists === false) {
                    return { key: 'does_not_exist', inputValue: true };
                }
            }
            
            switch (fieldType) {
                case 'String':
                    return this.parseStringCondition(fieldValue);
                case 'Number':
                    return this.parseNumberCondition(fieldValue);
                case 'Boolean':
                    return this.parseBooleanCondition(fieldValue);
                case 'Date':
                    return this.parseDateCondition(fieldValue);
                case 'Array':
                    return this.parseArrayCondition(fieldValue);
                case 'Object':
                    return this.parseObjectCondition(fieldValue);
                default:
                    return null;
            }
        },
        // 解析字符串条件
        parseStringCondition(fieldValue) {
            if (typeof fieldValue === 'string') {
                return { key: 'equals', inputValue: fieldValue };
            }
            
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$ne !== undefined) {
                    return { key: 'does_not_equal', inputValue: fieldValue.$ne };
                }
                if (fieldValue.$regex !== undefined) {
                    const regex = fieldValue.$regex;
                    if (regex.startsWith('^\\Q') && regex.endsWith('\\E')) {
                        // starts_with
                        const value = regex.slice(3, -2);
                        return { key: 'starts_with', inputValue: value };
                    }
                    if (regex.startsWith('\\Q') && regex.endsWith('\\E$')) {
                        // ends_with
                        const value = regex.slice(2, -3);
                        return { key: 'ends_with', inputValue: value };
                    }
                    if (fieldValue.$options === 'i') {
                        // contains_string
                        return { key: 'contains_string', inputValue: regex };
                    }
                }
            }
            
            return null;
        },
        // 解析数字条件
        parseNumberCondition(fieldValue) {
            if (typeof fieldValue === 'number') {
                return { key: 'equals', inputValue: fieldValue };
            }
            
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$ne !== undefined) {
                    return { key: 'does_not_equal', inputValue: fieldValue.$ne };
                }
                if (fieldValue.$gt !== undefined) {
                    return { key: 'greater_than', inputValue: fieldValue.$gt };
                }
                if (fieldValue.$gte !== undefined) {
                    return { key: 'greater_than_or_equal', inputValue: fieldValue.$gte };
                }
                if (fieldValue.$lt !== undefined) {
                    return { key: 'less_than', inputValue: fieldValue.$lt };
                }
                if (fieldValue.$lte !== undefined) {
                    return { key: 'less_than_or_equal', inputValue: fieldValue.$lte };
                }
            }
            
            return null;
        },
        // 解析布尔条件
        parseBooleanCondition(fieldValue) {
            if (typeof fieldValue === 'boolean') {
                return { key: 'equals', inputValue: fieldValue };
            }
            
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$ne !== undefined) {
                    return { key: 'does_not_equal', inputValue: fieldValue.$ne };
                }
            }
            
            return null;
        },
        // 解析日期条件
        parseDateCondition(fieldValue) {
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$lte && fieldValue.$lte.__type === 'Date') {
                    return { key: 'is_before', inputValue: fieldValue.$lte.iso };
                }
                if (fieldValue.$gte && fieldValue.$gte.__type === 'Date') {
                    return { key: 'is_after', inputValue: fieldValue.$gte.iso };
                }
            }
            
            return null;
        },
        // 解析数组条件
        parseArrayCondition(fieldValue) {
            if (typeof fieldValue === 'string' || typeof fieldValue === 'number') {
                return { key: 'contains_string', inputValue: fieldValue };
            }
            
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                if (fieldValue.$ne !== undefined) {
                    if (typeof fieldValue.$ne === 'string') {
                        return { key: 'without_string', inputValue: fieldValue.$ne };
                    }
                    if (typeof fieldValue.$ne === 'number') {
                        return { key: 'without_number', inputValue: fieldValue.$ne };
                    }
                }
            }
            
            return null;
        },
        // 解析对象条件
        parseObjectCondition(fieldValue) {
            if (typeof fieldValue === 'object' && fieldValue !== null) {
                // 检查是否是key存在/不存在的条件
                const keys = Object.keys(fieldValue);
                if (keys.length === 1) {
                    const key = keys[0];
                    const keyCondition = fieldValue[key];
                    
                    if (typeof keyCondition === 'object' && keyCondition !== null) {
                        if (keyCondition.$exists === true) {
                            return { key: 'key_exists', inputValue: key };
                        }
                        if (keyCondition.$exists === false) {
                            return { key: 'key_not_exist', inputValue: key };
                        }
                    }
                }
            }
            
            return null;
        }
    }
});
</script>

<style scoped lang='css'>
.class_condition {

}
</style>
